import { SelectCptTaxonomy } from '../_components/select-cpt-taxonomy';
import { SitemapCheckboxControl } from '../_components/checkbox';
import { LinkedPaginationPanel } from '../_components/linked-pagination-panel';
import metadata from '../../../blocks/grouped/block.json';

//  Import core block libraries
const { __ } = wp.i18n;
const { InspectorControls, useBlockProps } = wp.blockEditor;
const {
	PanelBody,
	PanelRow,
	//RadioControl,
	SelectControl,
	//ColorPicker
} = wp.components;
const { registerBlockType } = wp.blocks;
const ServerSideRender = wp.serverSideRender;
const { applyFilters } = wp.hooks;

/**
 * Register block
 */
export default registerBlockType(metadata.name, {
	apiVersion: metadata.apiVersion,
	title: metadata.title,
	icon: metadata.icon,
	keywords: [
		__('Sitemap', 'simple-sitemap'),
		__('Group', 'simple-sitemap'),
		__('HTML Sitemap', 'simple-sitemap'),
	],
	category: metadata.category,
	example: metadata.example,
	supports: metadata.supports,
	edit: function Edit(props) {
		const blockProps = useBlockProps({
			className: 'simple-sitemap-editor-preview-wrapper',
		});
		const {
			attributes: {
				id,
				show_excerpt,
				show_label,
				links,
				block_taxonomy,
				block_post_type,
				order,
				orderby,
				paginate,
				page_size,
			},
			setAttributes,
			attributes,
		} = props;

		function updateShowExcerpt(isChecked) {
			setAttributes({ show_excerpt: isChecked });
		}

		function updateShowLabel(isChecked) {
			setAttributes({ show_label: isChecked });
		}

		function updateLinks(isChecked) {
			setAttributes({ links: isChecked });
		}

		const sitemapGroupGeneralSettings = applyFilters(
			'sitemap-group-general-settings',
			'',
			props
		);
		const sitemapGroupGeneralStyles = applyFilters(
			'sitemap-group-general-styles',
			'',
			props
		);
		const sitemapGroupFeaturedImage = applyFilters(
			'sitemap-group-featured-image',
			'',
			props
		);

		return [
			<InspectorControls key="simple-sitemap-group-block-controls">
				<PanelBody title={__('General Settings', 'simple-sitemap')}>
					<PanelRow className="simple-sitemap">
						<SelectCptTaxonomy
							setAttributes={setAttributes}
							multi={false}
							block_post_type={block_post_type}
							block_taxonomy={block_taxonomy}
						/>
					</PanelRow>
					<PanelRow className="simple-sitemap order-label">
						<h3 style={{ marginBottom: '-12px' }}>Post ordering</h3>
					</PanelRow>
					<PanelRow className="simple-sitemap order">
						<SelectControl
							label="Orderby"
							value={orderby}
							options={[
								{ label: 'Title', value: 'title' },
								{ label: 'Date', value: 'date' },
								{ label: 'ID', value: 'ID' },
								{ label: 'Author', value: 'author' },
								{ label: 'Name', value: 'name' },
								{ label: 'Modified', value: 'modified' },
							]}
							onChange={(value) => {
								setAttributes({ orderby: value });
							}}
						/>
						<SelectControl
							label="Order"
							value={order}
							options={[
								{ label: 'Ascending', value: 'asc' },
								{ label: 'Descending', value: 'desc' },
							]}
							onChange={(value) => {
								setAttributes({ order: value });
							}}
						/>
					</PanelRow>
					<PanelRow className="simple-sitemap general-chk">
						<SitemapCheckboxControl
							value={show_label}
							label="Display post type label"
							updateCheckbox={updateShowLabel}
						/>
					</PanelRow>
					<PanelRow className="simple-sitemap general-chk">
						<SitemapCheckboxControl
							value={show_excerpt}
							label="Display post excerpt"
							updateCheckbox={updateShowExcerpt}
						/>
					</PanelRow>
					<PanelRow className="simple-sitemap general-chk">
						<SitemapCheckboxControl
							value={links}
							label="Display sitemap links"
							updateCheckbox={updateLinks}
						/>
					</PanelRow>
					{sitemapGroupGeneralSettings}
				</PanelBody>
				<LinkedPaginationPanel
					id={id}
					idPrefix="sitemap-group"
					paginate={paginate}
					pageSize={page_size}
					setAttributes={setAttributes}
					help={__(
						'Each taxonomy section receives its own bounded page links.',
						'simple-sitemap'
					)}
					entriesLabel={__(
						'Entries per section page',
						'simple-sitemap'
					)}
				/>
				{sitemapGroupGeneralStyles}
				{sitemapGroupFeaturedImage}
			</InspectorControls>,
			<div
				key="simple-sitemap-server-side-render-component"
				{...blockProps}
			>
				<ServerSideRender
					block="wpgoplugins/simple-sitemap-group-block"
					attributes={attributes}
				/>
			</div>,
		];
	},
	save() {
		return null;
	},
});
